import type {ReactNode} from 'react';
import {BlockStack, Card, Page, Text} from '@shopify/polaris';
import {Brand} from '@slj/ui/brand';

/**
 * Chrome for the unauthenticated pages (sign-in, join, forgot/reset): a narrow card on
 * the secondary background, brand centered above. Authenticated pages use the shared
 * AppFrame shell instead.
 *
 * The width comes from Polaris `Page narrowWidth`, not a bespoke maximum — the app has
 * exactly one content width that Page does not own (cook mode, in recipes), and this is
 * not it.
 */
export function AuthLayout({title, children}: {title: string; children?: ReactNode}) {
  // A plain block, NOT a centring grid: a grid item sizes to max-content, which would
  // collapse Page below its own max-width and undo the point of using it. Page centres
  // itself horizontally; this div only paints the full-viewport background.
  return (
    <div
      style={{
        minHeight: '100dvh',
        background: 'var(--p-color-bg-surface-secondary)',
        paddingBlock: 'var(--p-space-800)',
      }}
    >
      <Page narrowWidth>
        <BlockStack gap="500">
          <div style={{display: 'flex', justifyContent: 'center'}}>
            <Brand size={40} />
          </div>
          <Card>
            <BlockStack gap="400">
              <Text as="h1" variant="headingLg">
                {title}
              </Text>
              {children}
            </BlockStack>
          </Card>
        </BlockStack>
      </Page>
    </div>
  );
}
